export enum AdminBackgroundTaskStatus {
  InProgress = 'IN_PROGRESS',
  Done = 'DONE',
}
